'use strict'

const pluginsManager = require('./pluginsManager')()
const fixPageData = require('./fixPageData')
module.exports = {
    fixPageData: fixPageData.factory(pluginsManager)
}
